module.exports = __webpack_public_path__ + "img/type9999.25b0e14d.png";